import { render, staticRenderFns } from "./CbsRefsidPicker.vue?vue&type=template&id=0675d81f&scoped=true"
import script from "./CbsRefsidPicker.vue?vue&type=script&lang=js"
export * from "./CbsRefsidPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0675d81f",
  null
  
)

export default component.exports